export const capitalize = (word?: string): string | undefined =>
	word && word[0].toUpperCase() + word.slice(1);
